import { RouteRecordRaw } from "vue-router";
import { RoutePermission } from "@/router/index";

export const organizationRoutes: RouteRecordRaw[] = [
	{
		path: "/organizations/:organizationId",
		name: "organization-overview",
		props: true,
		component: () => import("@/views/organizations/OrganizationOverview.vue"),
		meta: {
			pageName: "Organization Overview",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**",
		},
	},
	{
		path: "/organizations/:organizationId/trial-get-started",
		name: "organization-trial-get-started",
		props: true,
		component: () => import("@/views/TrialGetStartedView.vue"),
		meta: {
			pageName: "Organization Trial Get Started",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/trial-get-started",
		},
	},
	{
		path: "/organizations/:organizationId/schedule",
		name: "organization-schedule",
		props: true,
		component: () => import("@/components/Entity/SchedulingTab.vue"),
		meta: {
			pageName: "Organization Schedule",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/schedule",
		},
	},
	{
		path: "/organizations/:organizationId/onboarding",
		name: "organization-onboarding",
		props: true,
		component: () => import("@/components/Onboarding/OrganizationOnboarding.vue"),
		meta: {
			pageName: "Organization Onboarding",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/onboard",
		},
	},
	{
		path: "/organizations/:organizationId/communications",
		name: "organization-communications",
		props: true,
		component: () => import("@/components/Entity/CommunicationsTab.vue"),
		meta: {
			pageName: "Organization Communications",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/communications",
		},
	},
	{
		path: "/organizations/:organizationId/productions",
		name: "organization-productions",
		props: true,
		component: () => import("@/components/Entity/ProductionsTab.vue"),
		meta: {
			pageName: "Organization Productions",
			//permission: RoutePermission.Manage,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/productions",
		},
	},
	{
		path: "/organizations/:organizationId/availability",
		name: "organization-availability",
		props: true,
		component: () => import("@/components/Entity/AvailabilityTab.vue"),
		meta: {
			pageName: "Organization Availability",
			//permission: RoutePermission.Manage,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/availability",
		},
	},
	{
		path: "/organizations/:organizationId/activation/callback",
		name: "organization-activation-callback",
		props: (route) => ({
			...route.params,
			checkoutSessionId: route.query.session_id,
		}),
		component: () => import("@/views/productions/activation/ProductionActivationCallbackView.vue"),
		meta: {
			pageName: "Organization Activation Callback",
			//permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/activation/callback",
		},
	},
	{
		path: "/organizations/:organizationId/settings",
		name: "organization-settings",
		props: true,
		component: () => import("@/components/Entity/SettingsTab.vue"),
		meta: {
			pageName: "Organization Settings",
			//permission: RoutePermission.Manage,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/settings",
		},
		children: [
			{
				path: "",
				name: "organization-settings-home",
				props: true,
				component: () => import("@/components/Entity/EntitySettingsMenuMobile.vue"),
				meta: {
					pageName: "Organization Settings General",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/general",
				},
			},
			{
				path: "general",
				name: "organization-settings-general",
				props: true,
				component: () => import("@/components/Entity/Settings/GeneralSettings.vue"),
				meta: {
					pageName: "Organization Settings General",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/general",
				},
			},
			{
				path: "subscription",
				name: "organization-settings-subscription",
				props: true,
				component: () => import("@/components/Entity/Settings/SubscriptionSettings.vue"),
				meta: {
					pageName: "Organization Settings Subscription",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/subscription",
					boxed: true,
					fullWidth: true,
				},
			},
			{
				path: "logo",
				name: "organization-settings-logo",
				props: true,
				component: () => import("@/components/Entity/Settings/LogoSettings.vue"),
				meta: {
					pageName: "Organization Settings Logo",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/logo",
				},
			},
			{
				path: "upgrade-assistant",
				name: "organization-settings-upgrade-assistant",
				props: true,
				component: () => import("@/components/Entity/Settings/UpgradeAssistant.vue"),
				meta: {
					pageName: "Organization Settings Upgrade Assistant",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/upgrade-assistant",
				},
			},
			{
				path: "venues",
				name: "organization-settings-venues",
				props: true,
				component: () => import("@/components/SelfContained/VenueSettings.vue"),
				meta: {
					pageName: "Organization Settings Venues",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/venues",
				},
			},
			{
				path: "report-templates",
				name: "organization-settings-report-templates",
				props: true,
				component: () => import("@/components/Entity/Reports/Templates/ReportTemplatesTable.vue"),
				meta: {
					pageName: "Organization Settings Report Templates",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/report-templates",
					boxed: true,
					fullWidth: true,
				},
			},
			{
				path: "report-templates/:reportTemplateId",
				name: "organization-settings-report-template-editor",
				props: true,
				component: () => import("@/components/Entity/Reports/Templates/ReportTemplateEditor.vue"),
				meta: {
					pageName: "Organization Settings Report Template Editor",
					//permission: RoutePermission.Manage,
					permissionId: "organizationId",
					friendlyPath: "/organizations/**/settings/report-templates/**",
					boxed: true,
					fullWidth: true,
				},
			},
		],
	},
	{
		path: "/organizations/:organizationId/people",
		name: "organization-people",
		props: true,
		component: () => import("@/components/Entity/People/PeopleMembersView.vue"),
		meta: {
			pageName: "Organization People",
			// permission: RoutePermission.Access,
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/people",
			fullWidth: true,
		},
	},
	{
		path: "/organizations/:organizationId/people/requests",
		name: "organization-people-requests",
		props: true,
		component: () => import("@/components/Entity/People/PeopleRequestsView.vue"),
		meta: {
			pageName: "Organization People Requests",
			permissionId: "organizationId",
			friendlyPath: "/organizations/**/people/requests",
			fullWidth: true,
		},
	},
];
